// Other Actions: the same step (2026-10-27, docs/contact-view.md "Other
// Actions: the same step"). A step a person starts from the Manual Panel is
// a step on the contact's suggestion, built like the proposed one; the
// panel's window shows it with the Proposed Steps' own step component, in
// the current layout (pipeline or agent draft). The window registers one
// slot (a DOM element) per step index here, and SuggestionPanel.jsx renders
// that step into it (a React portal), with its own state: the inputs, the
// disposition check, Process, View calls and the reply. When the window
// closes, the slot goes and the step is no longer shown there.
//
// A step in an Other Actions window keeps its own Check / Process on either
// layout (2026-10-29): on the agent draft panel the one button processes the
// list's steps, but never a step started from Other Actions, so the window is
// where it runs. The agent panel's unchecked-step rule does not apply there.
//
// A tiny store, no React: register / unregister, a version for
// useSyncExternalStore, and the lookup by conversation, suggestion and step.

// The Other Actions buttons whose window shows the step this way.
export const SAME_STEP_TYPES = new Set(['process_return_refund', 'process_replacement', 'resend_return_label', 'refund_freight_trq', 'refund_tax_trq'])

const slots = []
const listeners = new Set()
let version = 0

function changed() {
  version += 1
  for (const fn of listeners) fn()
}

// { conversationId, suggestionId, index, element } -> unregister().
export function registerStepSlot({ conversationId, suggestionId, index, element }) {
  if (!conversationId || !suggestionId || !Number.isInteger(index) || !element) return () => {}
  const entry = { conversationId, suggestionId, index, element }
  slots.push(entry)
  changed()
  return () => {
    const at = slots.indexOf(entry)
    if (at >= 0) {
      slots.splice(at, 1)
      changed()
    }
  }
}

// The element step `index` of this suggestion renders into, or null. The
// latest registration wins (two windows for the same step: the newer).
export function stepSlotFor(conversationId, suggestionId, index) {
  for (let i = slots.length - 1; i >= 0; i--) {
    const s = slots[i]
    if (s.conversationId === conversationId && s.suggestionId === suggestionId && s.index === index) return s.element
  }
  return null
}

export function subscribeStepSlots(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function stepSlotsVersion() {
  return version
}

// The step indexes a Manual Panel request added or reused, in order: the
// route's actionIndices when it sent them, else its one actionIndex.
export function manualStepIndices(res) {
  if (Array.isArray(res?.actionIndices) && res.actionIndices.length) return res.actionIndices.filter((i) => Number.isInteger(i))
  return Number.isInteger(res?.actionIndex) ? [res.actionIndex] : []
}

// Whether a step shows its own Process (and, after Check, the return step's
// Process): always on the pipeline panel; on the agent draft panel only in an
// Other Actions window (2026-10-29), since the one button skips that step.
export function stepOwnProcessShown({ agentLayout = false, inWindow = false } = {}) {
  return !agentLayout || Boolean(inWindow)
}
